import { api } from "../../services/NetworkBase";

export async function GetTestLibs(
  startDate,
  endDate,
  orderStatus,
  searchText,
  page,
  pageSize
) {
  try {
    let response = await api
      .get(
        `vlp/test-lib?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&orderStatus=${orderStatus}&pageSize=${pageSize}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestLib(orderNumber) {
  try {
    const encodedUrl = encodeURIComponent(orderNumber);
    let response = await api.get(`vlp/test-lib/${encodedUrl}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetAllTests() {
  try {
    let response = await api.get(`vlp/test-lib/all`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SearchTests(term) {
  try {
    let response = await api.get(`vlp/test-lib/search?term=${term}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}




export async function UpdateTestLib(testLib) {
  try {
    let response = await api.put("vlp/test-lib", {
      json: testLib,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTestLib(testLib) {
  try {
    let response = await api.post("vlp/test-lib", {
      json: testLib,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestLib(testCode) {
  try {
    const encodedUrl = encodeURIComponent(testCode);
    let response = await api.delete(`vlp/test-lib/${encodedUrl}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestSlate(testCode) {
  try {
    const encodedUrl = encodeURIComponent(testCode);
    let response = await api.delete(`vlp/test-lib/slate/${encodedUrl}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestFormula(formulaId) {
  try {
    const encodedUrl = encodeURIComponent(formulaId);
    let response = await api
      .delete(`vlp/test-lib/formula/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestFormula(formulaId) {
  try {
    const encodedUrl = encodeURIComponent(formulaId);
    let response = await api
      .get(`vlp/test-lib/test-formulas/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

//AddTestFormula, UpdateTestFormula

export async function AddTestFormula(formula) {
  try {
    let response = await api.post("vlp/test-lib/test-formulas", {
      json: formula,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateTestFormula(formula) {
  try {
    let response = await api.put("vlp/test-lib/test-formulas", {
      json: formula,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestCategory(categoryId) {
  try {
    const encodedUrl = encodeURIComponent(categoryId);
    let response = await api
      .delete(`vlp/test-lib/category/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestQualityControlType(qualityControlType) {
  try {
    const encodedQCType = encodeURIComponent(qualityControlType);
    let response = await api
      .delete(`vlp/test-lib/quality-control-type/${encodedQCType}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestInstrument(instrumentId) {
  try {
    const encodedUrl = encodeURIComponent(instrumentId);
    let response = await api
      .delete(`vlp/test-lib/instrument/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetSlate(jobId) {
  try {
    const encodedUrl = encodeURIComponent(jobId);
    let response = await api.get(`vlp/test-lib/slates/${encodedUrl}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestSlates(
  startDate,
  endDate,
  orderStatus,
  searchText,
  page,
  pageSize
) {
  try {
    let response = await api
      .get(
        `vlp/test-lib/slates?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&orderStatus=${orderStatus}&pageSize=${pageSize}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}


export async function GetMultiSelectTestSlates() {
  try {
    let response = await api.get(`vlp/test-lib/slates/multi-select`).json();
    return response;
  } catch (error) {
    throw error;
  }
}
export async function GetAllTestSlates() {
  try {
    let response = await api.get(`vlp/test-lib/slates/all`).json();
    return response;
  } catch (error) {
    throw error;
  }
}
export async function GetMultiSelectTestLib() {
  try {
    let response = await api.get(`vlp/test-lib/multi-select`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestFormulas() {
  try {
    let response = await api.get(`vlp/test-lib/test-formulas`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestCategories() {
  try {
    let response = await api.get(`vlp/test-lib/test-categories`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateTestCategory(cat) {
  try {
    let response = await api.put("vlp/test-lib/test-categories", { json: cat });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTestCategory(cat) {
  try {
    let response = await api.post("vlp/test-lib/test-categories", {
      json: cat,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
//SaveTestInstrument,
//UpdateTestInstrument

export async function UpdateTestInstrument(inst) {
  try {
    let response = await api.put("vlp/test-lib/test-instruments", {
      json: inst,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTestInstrument(inst) {
  try {
    let response = await api.post("vlp/test-lib/test-instruments", {
      json: inst,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestInstruments() {
  try {
    let response = await api.get(`vlp/test-lib/test-instruments`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestQualityControlTypes() {
  try {
    let response = await api
      .get(`vlp/test-lib/test-quality-control-types`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// SaveTestQualityControlType,
//   UpdateTestQualityControlType,

export async function UpdateTestQualityControlType(qcType) {
  try {
    let response = await api.put("vlp/test-lib/test-quality-control-types", {
      json: qcType,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTestQualityControlType(qcType) {
  try {
    let response = await api.post("vlp/test-lib/test-quality-control-types", {
      json: qcType,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateSlate(slate) {
  try {
    let response = await api.put("vlp/test-lib/slates", {
      json: slate,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveSlate(slate) {
  try {
    let response = await api.post("vlp/test-lib/slates", {
      json: slate,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
//DeleteSlate

export async function DeleteSlate(recordid) {
  try {
    let response = await api.delete(`vlp/test-lib/slates/${recordid}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

/**
 * Removes the given tests from a slate.
 * Slate tests are listed with AssignSlatesService.GetSlateTests and added with
 * AssignTestsService.AssignTests({ itemType: "Slate" }).
 * @param {string} jobId - Slate id
 * @param {string[]} testCodes - Test codes to remove
 * @returns {Promise<Object>} - { results: <number of tests removed> }
 */
export async function RemoveSlateTests(jobId, testCodes) {
  try {
    const encodedJobId = encodeURIComponent(jobId.trim());
    let response = await api
      .post(`vlp/test-lib/slates/${encodedJobId}/tests/remove`, {
        json: { testCodes },
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

/**
 * Saves the display order of the tests on a slate.
 * @param {string} jobId - Slate id
 * @param {string[]} testCodes - Test codes in the desired order
 * @returns {Promise<Object>} - { results: true }
 */
export async function ReorderSlateTests(jobId, testCodes) {
  try {
    const encodedJobId = encodeURIComponent(jobId.trim());
    let response = await api
      .put(`vlp/test-lib/slates/${encodedJobId}/tests/reorder`, {
        json: { testCodes },
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
